import { DisctionaryContent } from "src/app/services/sitecoreDictionary/dictionary-content.service";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, DoCheck } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CamService } from 'src/app/services/camService/cam.service';
import { RegistationUtilitiesService } from '../../../../modules/registration/services/registation-utilities.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { customEmailValidator, } from 'src/app/shared/Validators/special-character-validation';
import { Subject, takeUntil, debounceTime } from 'rxjs';
import { City, State } from 'src/app/models/interface/cam.interface'
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ApiResponse } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { CompanyProfileData, MasterItem, RegistrationMasterData } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { jwtDecode } from 'jwt-decode';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { HeaderStateService } from 'src/app/services/commonService/header-state.service';
import { SignUpContentServiceService } from 'src/app/modules/registration/services/sign-up-content-service.service';
import { environment } from 'src/environments/environment';
import { NgIf, NgFor, NgClass, NgStyle } from '@angular/common';
import { WaitingComponent } from '../../../../shared/components/waiting/waiting.component';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ContentService } from '../../services/content.service';

@Component({
  selector: 'app-company-detail',
  templateUrl: './company-detail.component.html',
  styleUrls: ['./company-detail.component.scss'],
  imports: [NgIf, WaitingComponent, MatIcon, NgFor, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatSuffix, MatSelect, MatOption, NgSelectComponent, AutoBlurSelectDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective, NgClass, NgStyle, MatButton, MatProgressSpinner]
})
export class CompanyDetailComponent implements OnInit, OnDestroy, DoCheck {
  previewUrl: string | ArrayBuffer | null = null;
  selectedFileName: string | null = null;
  imagePathUpdate: string | null = null;
  selectedFileImage: any;
  companydetails: any;
  companymasters: any;
  editcomapany: boolean = false;
  budgetOptions: MasterItem[] = [];
  businessOptions: MasterItem[] = [];
  employeeOptions: MasterItem[] = [];
  companyForm: FormGroup;
  isCityDirty = false;
  noResultsFound = false;
  countries: any[] = [];
  filteredCities: { cityName: string; cityCode: string }[] = [];
  selectedCity: City | null = null;
  PreviousCity: string = '';
  PreviousCityCode: string = 'SA';
  PreviousCountry: string = '';
  PreviousCountryCode: string = '';
  countriesLists: any[] = [];
  branchId: any
  accountNo: any;
  editpersonal: boolean = false;
  circleButton: boolean = false
  originalBusinessLoyaltyNumber: string = '';
  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }
  userData: any = {};
  fileControll: boolean = false;
  commonObjPipes: any = {
    countyname: { pipe: [], all: [] },
    countryCode: { pipe: [], all: [] },
    cityName: { pipe: [], all: [] },
  }
  warningResults: any[] = [];
  content: any;
  registrationContent: any;
  dictionaryContent: any;
  private readonly destroy$ = new Subject<void>();
  private readonly checkCompanySubject = new Subject<{ value: string, flag: string }>();
  imageUrl: string | ArrayBuffer | string = "";
  manageTravelerContent: any;
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  constructor(private readonly _ApiService: ApiService, private readonly fb: FormBuilder, private readonly _camService: CamService, private _headerState: HeaderStateService,
    private readonly registrationUtility: RegistationUtilitiesService, public _CommonService: CommonService, private readonly _ToastrApiService: ToastrApiService, private readonly _cdr: ChangeDetectorRef, private readonly _CompanyManagementService: CompanyManagementService, private readonly contentService: CompanyManagementContentService, private readonly crypto: CryptoService, private regContentService: SignUpContentServiceService, private readonly dictionaryContentService: DisctionaryContent, private readonly manageTravelercontentService: ContentService, private _dictionaryContentService: DisctionaryContent) {
    this.companyForm = this.fb.group({
      companyName: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(200), Validators.pattern('^[A-Za-z0-9&. ]*$'),],],
      natureofBusiness: ['', [Validators.required, Validators.maxLength(200)]],
      registrationID: [''],
      taxNo: [''],
      postCode: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(10), Validators.pattern('^[0-9]*$'),],],
      websiteURL: ['', [Validators.minLength(5), Validators.maxLength(200), Validators.pattern(/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/)]],
      address: ["", [Validators.required, Validators.minLength(5), Validators.maxLength(150)],],
      emailAddress: ['', [Validators.email, Validators.maxLength(100), customEmailValidator()]],
      mobileNo: ['', [Validators.minLength(8), Validators.maxLength(12)]],
      phoneNo: ['', [Validators.maxLength(12), Validators.minLength(8),]],
      noOfUsers: ['', Validators.required],
      travelBudget: ['', [Validators.required, Validators.maxLength(20)]],
      cityName: [null, Validators.required],
      additionalRef1: ['', [Validators.minLength(6), Validators.maxLength(30)]],
      additionalRef2: ['', [Validators.minLength(6), Validators.maxLength(30)]],
      additionalRef3: ['', [Validators.minLength(6), Validators.maxLength(30)]],
      additionalRef4: ['', [Validators.minLength(6), Validators.maxLength(30)]],
      additionalRef5: ['', [Validators.minLength(6), Validators.maxLength(30)]],
      language: ['GB'],
      countryCode: ['', Validators.required],
      buildingNumber: [''],
      districtName: [''],
      faxno: ['', [Validators.maxLength(15), Validators.minLength(6)]],
      countryName: [null, Validators.required],
      accountNo: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(4)]],
      countryCodee: ['',],
      companyImage: [null],
      ImgFlag: "NOCHANGE"
    });
  }
  ngDoCheck() {
    this.alertWarning();
  }
  ngOnInit() {
    this.checkCompanySubject.pipe(
      debounceTime(1000),
      takeUntil(this.destroy$)
    ).subscribe(({ value, flag }) => {
      this.executeCheckCompany(value, flag);
    });

    this.Loader.isSpinner = true; // ✅ loader start
    setTimeout(() => {
      this.Loader.isSpinner = false; // ✅ 5 sec baad band
    }, 2000);

    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    });
    this.regContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.registrationContent = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.dictionaryContent = res;
    });
    this.manageTravelercontentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.manageTravelerContent = res;
    });
    this._ApiService.getCountriesData().then(($res) => {
      this.countriesLists = this._CommonService.groupCountriesFilter($res);
    }).catch((err) => {
      console.log(err);

    });
    let payload: any = {
      "B2BId": this.crypto.getValueFromKey('SUBAGENTID') as string,
      "B2BUserRole": this.crypto.getValueFromKey(
        'ISCORPTRAVELARRANGER'
      ) as string
    };
    this._camService.PostCompanyProfile(payload).then(($res: ApiResponse<CompanyProfileData>) => {

      if ($res.status == 'Success') {
        this.editpersonal = true;
        this.Loader.isEditableClicked = true;
        this.userData = $res.data;
        const corpLogo = this.userData?.corpCompanyLogo;

        if (corpLogo) {
          this.imagePathUpdate = this.getUpdatedLogoUrl(corpLogo);;
        }
        this.prefillForm(this.userData);
        this.companyForm.markAllAsTouched();
        this.companyForm.updateValueAndValidity();
      }
    }).catch((error) => {
      const errMsg = error?.message || error?.error?.message || 'Something went wrong while fetching company profile.';
      this._CompanyManagementService.view_error_message(errMsg, error?.code);
      this._ToastrApiService.show('error', errMsg)
    })

    this._camService.GetCompanyMasters().then(($res: ApiResponse<RegistrationMasterData[]>) => {

      this.companymasters = $res.data;
      this.businessOptions = this.companymasters.natureOfBusinessMaster || [];
      this.employeeOptions = this.companymasters.numberOfEmployeesMaster || [];
      this.budgetOptions = this.companymasters.travelBudgetMaster || [];
    }).catch((error) => {
      console.log(error)
    });

    this.getBranchId()



    this.companyForm.get('countryName')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
      this.updateRegistrationIdValidators(value);

      const countryData = this.countriesLists.find((c: any) => c.countryName === value);
      const selectedCountry = countryData ? countryData.isoCode : this.companyForm.get('countryCode')?.value;

      if (!selectedCountry) return;

      const companyName = this.companyForm.get('companyName')?.value?.trim();
      if (companyName && companyName.length >= 4 && (companyName !== this.userData?.corpCompanyName?.trim() || selectedCountry !== this.userData?.countryCode)) {
        this.performCompanyCheck(companyName, selectedCountry, 'NAME');
      }

      const registrationId = this.companyForm.get('registrationID')?.value?.trim();
      if (registrationId && registrationId.length >= 8 && (registrationId !== this.userData?.corpRegistrationID?.trim() || selectedCountry !== this.userData?.countryCode)) {
        this.performCompanyCheck(registrationId, selectedCountry, 'REGISTRATIONID');
      }

      const taxId = this.companyForm.get('taxNo')?.value?.trim();
      if (taxId && taxId.length >= 8 && (taxId !== this.userData?.taxNo?.trim() || selectedCountry !== this.userData?.countryCode)) {
        this.performCompanyCheck(taxId, selectedCountry, 'TAX');
      }
    });

    this.companyForm.get('countryCode')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val: any) => {
      const countryNameVal = this.companyForm.get('countryName')?.value;
      const countryData = this.countriesLists.find((c: any) => c.countryName === countryNameVal);
      const selectedCountry = countryData ? countryData.isoCode : val;

      if (!selectedCountry) return;

      const companyName = this.companyForm.get('companyName')?.value?.trim();
      if (companyName && companyName.length >= 4 && (companyName !== this.userData?.corpCompanyName?.trim() || selectedCountry !== this.userData?.countryCode)) {
        this.performCompanyCheck(companyName, selectedCountry, 'NAME');
      }

      const registrationId = this.companyForm.get('registrationID')?.value?.trim();
      if (registrationId && registrationId.length >= 8 && (registrationId !== this.userData?.corpRegistrationID?.trim() || selectedCountry !== this.userData?.countryCode)) {
        this.performCompanyCheck(registrationId, selectedCountry, 'REGISTRATIONID');
      }

      const taxId = this.companyForm.get('taxNo')?.value?.trim();
      if (taxId && taxId.length >= 8 && (taxId !== this.userData?.taxNo?.trim() || selectedCountry !== this.userData?.countryCode)) {
        this.performCompanyCheck(taxId, selectedCountry, 'TAX');
      }
    });


    // this.companyForm.get('countryCode')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
    //   this.updatePhoneNumberValidators()
    // })

    // this.updatePhoneNumberValidators()

  }
  getViewValue(value: string, options: { value: string; viewValue: string }[]): string {
    const option = options.find((opt) => opt.value === value);
    return option ? option.viewValue : '-';
  }

  displayFnn(option: { name: string; code: string } | null): string {
    return option ? option.name : '';
  }
  filteredCitiesFunc(countryCode: any, cityKey: string) {
    this.commonObjPipes[cityKey].all = [];
    this.commonObjPipes[cityKey].pipe = [];
    this.companyForm.get(cityKey)?.setValue(null);

    this.registrationUtility.getCities(countryCode?.code ?? countryCode, '').subscribe((cities) => {
      this.commonObjPipes[cityKey].all = cities;
      this.commonObjPipes[cityKey].pipe = cities;
      this.noResultsFound = cities.length === 0;
    }, (error) => { this.noResultsFound = true; });

  }
  getBranchId(): void {
    const token = localStorage.getItem('QlAccessToken');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      this.branchId = payload.branchId;
    } else {
      console.error('No token found in session storage');
    }
  }
  getSiteCoreArray(keyString: string): Array<any> {
    return this.registrationContent?.[keyString];
  }

  updateRegistrationIdValidators(countryName: string) {

    const registrationIdControl = this.companyForm.get('registrationID');
    const buildingControl = this.companyForm.get('buildingNumber');
    const districtControl = this.companyForm.get('districtName');
    const taxIdControl = this.companyForm.get('taxNo');

    try {
      if (countryName === 'Saudi Arabia') {
        // this.message = '';

        registrationIdControl?.setValidators([
          Validators.required,
          Validators.pattern(/^\d{10}$/),
        ]);

        buildingControl?.setValidators([
          Validators.required,
          Validators.pattern(/^\d{4}$/)
        ]);

        districtControl?.setValidators([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(150)
        ]);

        // ✅ ADD THIS
        taxIdControl?.setValidators([
          Validators.required,
          Validators.minLength(9),
          Validators.maxLength(15),
          Validators.pattern(/^[0-9]*$/)
        ]);

      } else {
        // this.message = '(Optional)';

        registrationIdControl?.setValidators([
          Validators.minLength(8),
          Validators.maxLength(15),
        ]);

        taxIdControl?.setValidators([
          Validators.minLength(8),
          Validators.maxLength(15),
        ]);

        buildingControl?.setValidators([
          Validators.maxLength(15),
        ]);

        districtControl?.setValidators([
          Validators.minLength(5),
          Validators.maxLength(150),
        ]);

      }

      // ✅ Update all controls
      registrationIdControl?.updateValueAndValidity();
      buildingControl?.updateValueAndValidity();
      districtControl?.updateValueAndValidity();
      taxIdControl?.updateValueAndValidity();

    } catch (error) {
      console.error('Error updating validators:', error);
    }
  }


  filterCountries(event: any, cityKey: string) {
    this.filteredCitiesFunc(event.isoCode, cityKey);
  }

  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  filterCities(value: string): City[] {
    const filterValue = value.toLowerCase();
    return this.filteredCities.filter((city) =>
      city.cityName.toLowerCase().includes(filterValue)
    );
  }

  getCountryName(
    selectedCountry: { name: string; code: string } | null
  ): string {
    return selectedCountry ? selectedCountry.name : '-';
  }

  private _filter(
    opt: { name: string; code: string }[],
    value: string
  ): { name: string; code: string }[] {
    const filterValue = value.toLowerCase();
    return opt.filter((item) => item.name.toLowerCase().includes(filterValue));
  }

  displayFn(option: any): any {
    return option?.name ? option.name : option;
  }
  displayFn2(option: any): any {
    return option?.isdCode ? option.isdCode : option;
  }
  onCityInput(event: Event): void {
    this.isCityDirty = true;
    const input = (event.target as HTMLInputElement).value;

    if (input !== this.PreviousCity) {
      this.companyForm.get('cityName')?.setErrors({ InvalidInput: true });
      this.companyForm.setErrors({ cityInvalid: true });
      this.companyForm.get('cityName')?.markAsTouched();
      this.companyForm.get('cityName')?.markAsDirty();
    } else {
      this.companyForm.get('cityName')?.setErrors(null);
      this.companyForm.get('cityName')?.markAsUntouched();
    }

    const stateGroupControl = this.companyForm.get('countryName');
    if (stateGroupControl && stateGroupControl.value) {
      const countryCode = this.companyForm.get('countryName')?.value;
      if (input.length >= 1 && countryCode) {
        this.registrationUtility.getCities(countryCode, input).subscribe((cities) => {
          this.filteredCities = cities;
          this.noResultsFound = cities.length === 0;
        }, (error) => { this.noResultsFound = true; });
      } else {
        this.filteredCities = [];
        this.noResultsFound = true;
        this.companyForm.get('cityName')?.setErrors({ noResults: true });
      }
    } else {
      this.filteredCities = [];
      this.noResultsFound = true;
      this.companyForm.get('cityName')?.setErrors({ noResults: true });
    }
  }

  onCitySelected(city: City) {
    this.selectedCity = city;
    this.PreviousCity = city.cityName;
    this.PreviousCityCode = city.cityCode;
  }
  displayFn1(state: State | null): string {
    return state ? state.name : '';
  }


  OnlyNumbers(event: KeyboardEvent): void {
    // List of invalid characters that should be blocked
    const invalidChars = [
      '<', '>', '$', ' ', '~', '"', "'", '`', '_', '-', '@', '%', '|', ',', '+', ';', '[', ']', ':', '--', '\\', '?', '#', '&', '^', '*', '!', '=', '(', ')', '{', '}'
    ];

    // Check if the pressed key is a number
    const isNumber = /^[0-9]$/.test(event.key);

    // Check the current input length
    const currentInputLength = (event.target as HTMLInputElement).value.length;

    // If the pressed key is not a number or is in the invalidChars array, prevent the input
    if (!isNumber || invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    const invalidChars = ['+', '-', '_'];
    const isNumeric = /^[0-9]$/.test(event.key);
    if (!isNumeric && !invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }
  Onlyrs(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const currentInputValue = inputElement.value;

    // Get the character being typed
    const typedChar = event.key;

    // If the character is a dot, check if the previous character was also a dot
    if (typedChar === '.' && currentInputValue.endsWith('.')) {
      this.companyForm.get('emailAddress')?.setErrors({ customEmailValidator: true });
      event.preventDefault();
    }
  }
  checkEmail(event: any): void {
    const email = event.target.value;
    const companyID = 'SAA';

    this.registrationUtility.CheckEmail(companyID, email).subscribe({
      next: (exists) => {
        if (exists) {
          this.companyForm.get('emailAddress')?.setErrors({ emailExists: true });
        } else {
          // Preserve other errors while clearing 'emailExists'
          const currentErrors = this.companyForm.get('emailAddress')?.errors;
          if (currentErrors) {
            // Remove only the 'emailExists' error
            const { emailExists, ...remainingErrors } = currentErrors;
            this.companyForm.get('emailAddress')?.setErrors(remainingErrors);
          }
        }
      },
      error: (error) => {
        const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
        this._CompanyManagementService.view_error_message(message, error?.code);
      }
    });
  }


  Editpersonal() {
    this.editpersonal = true;
    this.Loader.isEditableClicked = false;
    this.circleButton = true;

    this._CompanyManagementService.company_management_companyDetail('Edit')//GTM use
  }
  Cancel() {
    this.circleButton = false;
    this.editpersonal = false;
    this.Loader.isEditableClicked = true;
    this.errorMessage = '';
    this.prefillForm(this.userData);
    this._CompanyManagementService.company_management_companyDetail('Cancel')//GTM use

  }
  prefillForm(companyData: any): void {
    if (companyData) {
      const companyDetails = companyData;
      const { countryCode, mobileNo } = this.setCountryCodeAndMobileNo(companyDetails);
      this.originalBusinessLoyaltyNumber = companyDetails?.businessLoyaltyNumber;
      this.companyForm.patchValue({
        companyName: companyDetails.corpCompanyName,
        natureofBusiness: companyDetails.natureOfBusiness,
        registrationID: companyDetails.corpRegistrationID,
        taxNo: companyDetails.taxNo,
        postCode: companyDetails.postCode,
        districtName: companyDetails.districtName,
        buildingNumber: companyDetails.buildingNumber,
        websiteURL: companyDetails.companyUrl,
        address: companyDetails.address,
        countryName: companyDetails.countryName,
        emailAddress: companyDetails.emailAddress,
        countryCode: companyDetails.countryCode,
        countryCodee: countryCode,
        mobileNo: mobileNo,
        phoneNo: companyDetails.telephoneNo,
        noOfUsers: companyDetails.noOfUsers,
        accountNo: this.maskAccountNumber(companyDetails.businessLoyaltyNumber),
        faxno: companyDetails.faxNo,
        travelBudget: companyDetails.travelBudget,
        additionalRef1: companyDetails.additionalRef1,
        additionalRef2: companyDetails.additionalRef2,
        additionalRef3: companyDetails.additionalRef3,
        additionalRef4: companyDetails.additionalRef4,
        additionalRef5: companyDetails.additionalRef5,
        companyImage:
          (companyDetails?.corpCompanyLogo &&
            (companyDetails?.corpCompanyLogo === "DELETE" ||
              companyDetails?.corpCompanyLogo === "CHANGE" ||
              companyDetails?.corpCompanyLogo === "NOCHANGE"))
            ? ""
            : this.getUpdatedLogoUrl(companyDetails?.corpCompanyLogo),
      });

      this.companyForm.get('accountNo')?.disable();
      this.companyForm.get('companyName')?.disable();
      this.companyForm.get('registrationID')?.disable();
      this.companyForm.get('taxNo')?.disable();

      this.registrationUtility.getCities(companyDetails.countryCode, '').subscribe((cities) => {
        this.bindLists('cityName', cities);
        this.filteredCities = cities;
        this.noResultsFound = cities.length === 0;
        this.companyForm.get('cityName')?.setValue(companyDetails.cityName);
      }, (error) => {
        this.noResultsFound = true;
        const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
        this._CompanyManagementService.view_error_message(message, error?.code);
      });
    }


  }

  getUpdatedLogoUrl(corpLogo: string): string {
    if (!corpLogo) return '';

    if (['DELETE', 'CHANGE', 'NOCHANGE'].includes(corpLogo)) {
      return '';
    }

    if (!corpLogo.includes('http')) return corpLogo;
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.split('/business/')[0] + '/business/';

    const index = corpLogo.indexOf('images');
    if (index === -1) return corpLogo;
    const logoPath = corpLogo.substring(index);
    const updatedLogoUrl = baseUrl + logoPath;
    this.imagePathUpdate = updatedLogoUrl;
    this._headerState.setCompanyLogo(this.imagePathUpdate || '');
    return corpLogo;
  }

  setCountryCodeAndMobileNo(companyDetails: { mobileNo: string, countryCode: string }) {
    let countryCode = companyDetails.countryCode;
    let mobileNo = companyDetails.mobileNo;

    // Check if the Mobile_no contains a '-'
    if (mobileNo.includes('-')) {
      // Split based on '-'
      const parts = mobileNo.split('-');

      if (parts.length === 2) {
        countryCode = parts[0];
        mobileNo = parts[1];
      }
    } else {
      if (mobileNo.length > 8) {
        mobileNo = mobileNo;
      } else if (mobileNo.length <= 4) {
        countryCode = mobileNo;
      }
    }

    // Returning the final values of countryCode and mobileNo
    return { countryCode, mobileNo };
  }




  blockInvalidUrl(event: KeyboardEvent): void {
    // List of individual characters considered unsafe for XSS, SQL Injection, or path traversal
    const invalidChars = [
      '<', '>', '"', "'", '`', ';', '\\', '?', '+', '#', '%', '^', '*', '!', '=', '(', ')', '{', '}', '|', '&',
    ];


    // A simple regex to prevent sequences like '--', '/*' (for SQL Injection or comments in code)
    const forbiddenRegex = /--|\/\*|\*\/|;|<|>|['"]/g;

    // Allow characters for valid URLs like "https://", "www", ".", and "/" etc.
    const validUrlChars = /[a-zA-Z0-9\-\.\/\:\?&=]/;

    // Check if the key pressed is in the invalidChars array
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
      return;
    }

    // Check if the input is in a field that expects a URL
    const inputElement = event.target as HTMLInputElement;

    // Allow the initial 'https://' part for valid URLs
    if (inputElement && inputElement.value.startsWith('https://')) {
      // For URLs starting with https://, allow characters like "." and "/"
      if (!validUrlChars.test(event.key)) {
        event.preventDefault();
      }
      return;
    }

    // Check if the current input value (including the new key) matches the forbidden regex
    if (inputElement && forbiddenRegex.test(inputElement.value + event.key)) {
      event.preventDefault();
    }

    if ((inputElement && inputElement.value.endsWith('.com')) || '.in') {
      // For URLs starting with https://, allow characters like "." and "/"
      if (!validUrlChars.test(event.key)) {
        event.preventDefault();
      }
      return;
    }
  }
  block(event: KeyboardEvent): void {
  }

  CheckCompany(event: any, flag: string = 'NAME'): void {
    const value = event.target.value?.trim() || '';
    this.checkCompanySubject.next({ value, flag });
  }

  private executeCheckCompany(value: string, flag: string = 'NAME'): void {
    const countryNameVal = this.companyForm.get('countryName')?.value;
    const countryData = this.countriesLists.find((c: any) => c.countryName === countryNameVal);
    const selectedCountry = countryData ? countryData.isoCode : this.companyForm.get('countryCode')?.value;

    if (!value || !selectedCountry) {
      return;
    }

    if (flag === 'NAME') {
      if (value === this.userData?.corpCompanyName?.trim() && selectedCountry === this.userData?.countryCode) return;
      if (value.length < 4) return;
    }
    if (flag === 'REGISTRATIONID') {
      if (value === this.userData?.corpRegistrationID?.trim() && selectedCountry === this.userData?.countryCode) return;
      if (value.length < 8) return;
    }
    if (flag === 'TAX') {
      if (value === this.userData?.taxNo?.trim() && selectedCountry === this.userData?.countryCode) return;
      if (value.length < 8) return;
    }

    this.performCompanyCheck(value, selectedCountry, flag);
  }

  private performCompanyCheck(value: string, countryCode: string, flag: string): void {
    this.registrationUtility.CheckCompany(value, countryCode, flag).subscribe({
      next: (exists) => {
        let controlName = 'companyName';
        if (flag === 'REGISTRATIONID') controlName = 'registrationID';
        if (flag === 'TAX') controlName = 'taxNo';

        const control = this.companyForm.get(controlName);

        if (exists) {
          const currentErrors = control?.errors || {};
          control?.setErrors({
            ...currentErrors,
            CompanyExists: true,
          });
        } else {
          const currentErrors = control?.errors || {};
          if (currentErrors['CompanyExists']) {
            delete currentErrors['CompanyExists'];
            control?.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
          }
          control?.updateValueAndValidity();
        }
      },
      error: (error) => {
        const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
        this._CompanyManagementService.view_error_message(message, error?.code);
      },
    });
  }

  fileName: string = '';
  errorMessage: string = '';
  imagePreviewUrl: string | null = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.companyForm.markAsDirty();
    if (!input.files || input.files.length === 0) {
      this.resetImage(input);
      return;
    }

    const file = input.files[0];
    this.selectedFileImage = file;

    // ✅ File type validation
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      this.showFileValidationError('Invalid file type. Allowed: .jpg, .png', input);
      return;
    }

    // ✅ File size validation (NEW)
    const maxSizeInKB = 25;
    const fileSizeInKB = file.size / 1024;

    if (fileSizeInKB > maxSizeInKB) {
      this.showFileValidationError(`File size exceeds ${maxSizeInKB} KB.`, input);
      return;
    }

    // ✅ Continue with FileReader
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.onload = () => {
        const { width, height } = img;

        // ✅ Strict dimension validation (UPDATED)
        if (width > 250 || height > 100) {
          this.showFileValidationError(
            `Invalid dimensions (${width}x${height}px). Maximum allowed: 250x100 px.`,
            input
          );
          return;
        }

        // ✅ Valid image
        this.previewUrl = e.target.result;

        const base64String = e.target.result.split(',')[1];
        this.companyForm.patchValue({
          companyImage: {
            fileName: file.name,
            contentType: file.type,
            data: base64String
          },
          ImgFlag: "CHANGE"
        });

        this._cdr.detectChanges();
      };

      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  }

  /** Show file validation toast at top of screen and scroll up so it's visible. */
  private showFileValidationError(message: string, input: HTMLInputElement): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this._ToastrApiService.show('error', message);
    this.resetImage(input);
  }

  // ✅ Reset helper
  private resetImage(input: HTMLInputElement): void {
    input.value = '';
    this.selectedFileName = null;
    this.previewUrl = null;
    this.companyForm.patchValue({ companyImage: null });
    this._cdr.detectChanges();
  }

  updateCompanyDetails() {
    this._CompanyManagementService.company_management_companyDetail('Save')//GTM use

    // 🔹 Step 1: Basic loader setup
    this.Loader.isSpinner = true;
    this.circleButton = false;

    // 🔹 Step 2: Clone form values
    let copyForm = JSON.parse(JSON.stringify(this.companyForm.value));
    copyForm.accountNo = this.originalBusinessLoyaltyNumber;
    // 🔹 Step 3: Handle image flag logic
    if (!!this.selectedFileImage) {
      copyForm.companyImage = this.selectedFileImage;
    }
    // 🔹 Step 3.1: Set countryCodee from countriesLists (match isoCode → use code)
    const selectedIsoCode = copyForm.countryCode;
    const matchedCountry = this.countriesLists.find(
      (country: any) => country?.isoCode === selectedIsoCode
    );
    if (matchedCountry?.code) {
      copyForm.mobileExtensionCode = String(matchedCountry.code);
    }

    // 🔹 Step 4: Convert some fields to string
    copyForm.travelBudget = String(copyForm.travelBudget);
    copyForm.natureofBusiness = String(copyForm.natureofBusiness);
    copyForm.branchid = String(this.branchId);
    copyForm.mobileNo = `${copyForm.mobileNo}`;

    // 🔹 Step 5: Build FormData payload
    const formData = new FormData();

    const QlAccessToken = localStorage.getItem('QlAccessToken');
    if (QlAccessToken) {
      const decoded: any = jwtDecode(QlAccessToken);
      if (decoded?.AccountId) {
        formData.append("accountId", String(decoded.AccountId));
        formData.append('B2BLoyaltyNumber', String(decoded.businessLoyaltyNumber))
      }
    }
    Object.keys(copyForm).forEach(key => {
      const value = copyForm[key];

      if (value instanceof File) {
        formData.append(key, value, value.name);
      } else if (Array.isArray(value)) {
        value.forEach(v => {
          if (v instanceof File) {
            formData.append(key, v, v.name);
          } else {
            formData.append(key, v);
          }
        });
      } else if (value !== null && typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
      } else if (value !== undefined) {
        formData.append(key, value);
      }
    });

    // 🔹 Step 6: API call
    this._camService.PatchCompanyDetailsV1(formData).then(($res: any) => {
      if ($res.status?.toLowerCase() === "success") {

        if (this.companyForm.get('ImgFlag')?.value === 'DELETE') {
          localStorage.removeItem('companylogo');
          this._headerState.setCompanyLogo('');
        }

        this._ToastrApiService.show('success', "Company profile details updated successfully.");
        this._CompanyManagementService.save_success('Company details', 'Success') //GTM    
      } else {
        this._ToastrApiService.show('error', this.getCompanyToast('b2b.managecompany.companyinfonotupdated', "Company profile details could not be updated."));
        this._CompanyManagementService.company_save_error('Company profile details could not be updated.', 400)//GTM use
      }
    })
      .catch(error => {
        this._ToastrApiService.show('error', this.getCompanyToast('b2b.managecompany.companyinfonotupdated', "Company profile details could not be updated."));
        this._CompanyManagementService.company_save_error('Company profile details could not be updated.', 400)//GTM use

      })
      .finally(() => {
        this.Loader.isSpinner = false;
        this.Loader.isEditableClicked = true;
      });
  }




  alertWarning() {
    const warnings: any[] = [
      { message: "Please enter your company name.", required: true, control: "companyName" },
      { message: "Company Name cannot exceed 200 characters.", error: "maxlength", control: "companyName" },
      { message: "Please enter a valid input.", error: "noHtmlTagsValidator", control: "companyName" },
      { message: "Company name already exists.", error: "CompanyExists", control: "companyName" },
      { message: "Please enter valid input.", error: "pattern", control: "companyName" },
      { message: "Company name length must be greater than 4", error: "minlength", control: "companyName" },

      { message: "Please select nature of business.", required: true, control: "natureofBusiness" },

      { message: "Please enter your registration id.", required: true, control: "registrationID" },
      { message: "Please enter a valid input.", error: "pattern", control: "registrationID" },
      { message: "Please enter 10 digit for Saudi Arabia.", error: "minlength", control: "registrationID" },
      { message: "Please enter a valid input.", error: "forbiddenCharacters", control: "registrationID" },

      { message: "Please enter your tax number.", required: true, control: "taxNo" },
      { message: "Please enter a valid input.", error: "pattern", control: "taxNo" },
      { message: "Please enter 10 digit for Tax identification No. Saudi Arabia.", error: "minlength", control: "taxNo" },
      { message: "Please enter a valid input.", error: "forbiddenCharacters", control: "taxNo" },

      { message: "Please select the country code.", required: true, control: "countryName" },
      { message: "Please enter valid Input.", error: "noHtmlTagsValidator", control: "countryName" },
      { message: "Please enter valid Input.", error: "InvalidInput", control: "countryName" },

      { message: "Please enter your postal code.", required: true, control: "postCode" },
      { message: "Please enter a valid input.", error: "pattern", control: "postCode" },
      { message: "Postal code length must be greater than 5.", error: "minlength", control: "postCode" },

      { message: "Please select the city.", required: true, control: "cityName" },

      { message: "Please enter the head office address.", required: true, control: "address" },
      { message: "Head office address is required 200 characters.", error: "maxlength", control: "address" },
      { message: "Please enter a valid input.", error: "forbiddenCharacters", control: "address" },
      { message: "Address length must be greater than 5.", error: "minlength", control: "address" },

      { message: "Please enter email address.", required: true, control: "emailAddress" },
      { message: "Enter a valid email address.", error: "customEmailValidator", control: "emailAddress" },
      { message: "Enter a valid email address.", error: "email", control: "emailAddress" },
      { message: "Email address cannot exceed 30 characters.", error: "maxlength", control: "emailAddress" },
      { message: "This email already exists.", error: "emailExists", control: "emailAddress" },
      { message: "Please enter a valid input.", error: "forbiddenCharacters", control: "emailAddress" },
      { message: "Please enter a valid input.", error: "invalidEmail", control: "emailAddress" },

      { message: "Please enter mobile number.", required: true, control: "mobileNo" },
      { message: "Mobile number cannot exceed 10 digits.", error: "maxlength", control: "mobileNo" },
      { message: "Mobile number cannot be less than 10 digits.", error: "minlength", control: "mobileNo" },
      { message: "Please enter a valid input.", error: "pattern", control: "mobileNo" },

      { message: "Please enter phone number.", required: true, control: "phoneNo" },
      { message: "Phone number cannot exceed 10 digits.", error: "maxlength", control: "phoneNo" },
      { message: "Phone number cannot be less than 10 digits.", error: "minlength", control: "phoneNo" },
      { message: "Please enter a valid input.", error: "pattern", control: "phoneNo" },

      { message: "Company URL cannot exceed 50 characters.", error: "maxlength", control: "websiteURL" },
      { message: "Please enter a valid URL.", error: "invalidUrl", control: "websiteURL" }
    ]
    this.warningResults = [];
    warnings.forEach(($control: any) => {
      if (!!$control?.required) {
        if (this.companyForm.get($control.control)?.invalid && this.companyForm.get($control.control)?.touched && this.companyForm.get($control.control)?.errors?.['required']) {
          this.warningResults.push($control);
        }
      }
      if (!!$control?.error) {
        if (this.companyForm.get($control.control)?.errors?.[$control.error]) {
          this.warningResults.push($control);
        }
      }
    })
  }

  getImageUrl(path: string): string {
    if (!path) return '';

    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');

    return `${base}/${cleanPath}`;
  }


  blockInvalidCharacters(event: KeyboardEvent, controlName: string): void {
    if (controlName === 'address') {
      const allowedRegex = /^[a-zA-Z0-9 ,.\-&#\/]$/;
      if (!allowedRegex.test(event.key)) {
        event.preventDefault();
      }
    }

    if (controlName === 'faxno') {
      const allowedRegex = /^[0-9+\-()]$/;
      if (!allowedRegex.test(event.key)) {
        event.preventDefault()
      }

    }
  }

  public removeLogo(input?: HTMLInputElement): void {
    this.previewUrl = null;
    this.imageUrl = "";
    this.fileName = "";
    this.errorMessage = "";
    this.selectedFileName = null;
    this.selectedFileImage = null;
    // Reset the form control value
    this.companyForm.patchValue({
      companyImage: null,
      ImgFlag: "DELETE"
    });
    this.selectedFileImage = null;

    // ✅ Mark the control as dirty (user has made a change)
    this.companyForm.get('companyImage')?.markAsDirty();
    this.companyForm.get('companyImage')?.updateValueAndValidity();

    if (input) {
      input.value = '';
    }

    // 🔥 ADD THESE 2 LINES ONLY:
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
    // Trigger change detection
    this._cdr.detectChanges();

    this._ToastrApiService.show('success', 'Company logo removed successfully')

  }
  warningTextCustomize(text: string) {
    return text.replace('Warning:', '<strong>Warning:</strong>')
  }


  updatePhoneNumberValidators() {
    const phoneControl = this.companyForm.get('mobileNo');
    const selectedCountry = this.companyForm.get('countryCode')?.value;
    const countryCode = selectedCountry;
    // Check if India (ISD code +91 or 91)
    const isIndia = countryCode === '+91' || countryCode === '91' || countryCode === 'IN';

    if (isIndia) {
      // India: exactly 10 digits
      phoneControl?.setValidators([
        Validators.pattern(/^\d{10}$/),

      ]);
    } else {
      // Other countries: 6 to 12 digits
      phoneControl?.setValidators([
        Validators.minLength(6),
        Validators.maxLength(12)
      ]);
    }

    phoneControl?.updateValueAndValidity();
  }

  maskAccountNumber(accountNumber: string): string {
    if (!accountNumber) return '';

    return (
      accountNumber.substring(0, 2) +
      '*'.repeat(accountNumber.length - 4) +
      accountNumber.substring(accountNumber.length - 2)
    );
  }

  private getCompanyToast(messageID: string, fallback: string): string {
    return this.content?.toastMessageList?.find((item: any) => item.messageID === messageID)?.description || fallback;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
